__turbopack_context__.v({
  "content": "YghszG_content" + " " + "header-navbar-content",
  "item": "YghszG_item" + " " + "header-navbar-item",
  "list": "YghszG_list" + " " + "header-navbar-list",
  "navbar": "YghszG_navbar" + " " + "header-navbar",
});
